import { FiStar } from '@/components/react-icons/main';
import IconV2 from '@/components/v2/IconV2';
import { useArgSelector } from '@/redux/curriedSelectors/curriedSelectors';
import selectors from '@/redux/selectors/selectors';
import utilityAppIcons from '@/screens/workflows/schema/utilityAppIcons';
import React from 'react';
import LexicalDisplay from '@/components/lexicalInput/LexicalDisplay.jsx';

const AuditLogSliderContentBlock = ({ block }) => {
  const app = block?.appId ? useArgSelector(selectors.appById, block?.appId) : null;
  const isLexicalValue = block?.type === 'lexical';

  return (
    <>
      {isLexicalValue && <LexicalDisplay value={block} className={'audit-log-lexical-display'} variation="workflow" />}
      {!isLexicalValue && (
        <div className={`audit-log-item-content-block ${block?.type || ''}`}>
          {app && <IconV2 icon={app?.icon || utilityAppIcons[app?.slug || block.id] || FiStar} />}
          <span className="label">{`${block?.stepNumber || ''} ${block?.label || block?.value || ''}`.trim()}</span>
        </div>
      )}
    </>
  );
};

export default AuditLogSliderContentBlock;
